export default __webpack_public_path__ + "static/media/barilla.e97de6ef.png";